import { WebPaths } from '@griply/types';
import { getPathByString } from '@griply/utils';

// Not noAutoReloadPaths: these pages revoke the session themselves and their result screen leads to login.
const sessionRevokingPaths: ReadonlySet<WebPaths> = new Set([
  WebPaths.ConfirmEmailChange,
  WebPaths.RevertEmailChange,
]);

export const isSessionRevokingPath = (pathname: string): boolean => {
  const path = getPathByString(pathname);
  return !!path && sessionRevokingPaths.has(path);
};
